import React, { ReactElement } from 'react'
import { Button, Modal, Alert } from 'react-bootstrap'
import { LoadingBar } from 'components'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ConfirmButton from 'components/Buttons/ConfirmButton/ConfirmButton'

interface IProps {
  title: string,
  alertHeading?: string,
  content: string | JSX.Element,
  show: boolean,
  loading: boolean,
  disabled?: boolean,
  showCloseButton?: boolean,

  showConfirmButton?: boolean
  confirmButtonIcon?: IconProp
  confirmButtonTitle?: string,
  confirmButtonVariant?: string,

  showCancelButton?: boolean,
  cancelButtonIcon?: IconProp
  cancelButtonTitle?: string,

  showExtraButton?: boolean,
  thirdButtonIcon?: IconProp,
  thirdButtonTitle?: string,
  onThirdButton?: React.MouseEventHandler<HTMLElement>,

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: Array<string> | Array<ReactElement>,
  onShow?: () => void | Promise<void>,
  onCancel: (event: React.MouseEvent<HTMLElement> | undefined) => void,
  onSave: React.MouseEventHandler<HTMLElement>,

  className?: string,

  size?: 'sm' | 'lg' | 'xl'
}

const ConfirmModal = ({
  title,
  alertHeading,
  content,
  show,
  loading,
  disabled,
  errors,
  onCancel,
  onSave,
  cancelButtonTitle,
  confirmButtonTitle,
  confirmButtonVariant,
  showCancelButton,
  onShow,
  showCloseButton,
  showConfirmButton,
  confirmButtonIcon,
  cancelButtonIcon,
  thirdButtonIcon,
  thirdButtonTitle,
  showExtraButton,
  className,
  onThirdButton,
  size
}: IProps) => {

  return (
    <Modal
      size={size}
      className={className}
      show={show}
      onShow={onShow}
      onHide={() => onCancel(undefined)}>
      <Modal.Header closeButton={!loading && showCloseButton}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <LoadingBar loading={loading} />
      <Modal.Body>

        <Alert variant='danger' show={errors.length > 0}>
          {
            alertHeading
              ? <Alert.Heading>{alertHeading}</Alert.Heading>
              : <></>
          }
          <ul>
            {errors.map((value: string | ReactElement, index: number) => <li key={index}>{value}</li>)}
          </ul>
        </Alert>
        {content}
      </Modal.Body>
      <Modal.Footer>

        {showExtraButton && thirdButtonTitle &&
          <div className='me-auto'>
            <Button
              className='btn'
              variant='default'
              onClick={onThirdButton}
              disabled={loading}
            >
              {thirdButtonIcon &&
                <>
                  <FontAwesomeIcon icon={thirdButtonIcon} />
                  {' '}
                </>
              }

              {thirdButtonTitle}
            </Button>
          </div>
        }

        {showCancelButton ?
          <Button className='btn' variant='default' onClick={(e) => onCancel(e)} disabled={loading}>
            {cancelButtonIcon &&
              <>
                <FontAwesomeIcon icon={cancelButtonIcon} />
                {' '}
              </>
            }

            {cancelButtonTitle}
          </Button>
          : <></>
        }

        {showConfirmButton &&
          <ConfirmButton
            confirmButtonTitle={confirmButtonTitle}
            confirmButtonVariant={confirmButtonVariant}
            onSave={onSave}
            disabled={disabled}
            loading={loading}
            icon={confirmButtonIcon}
          />
        }
      </Modal.Footer>
    </Modal>
  )
}

ConfirmModal.defaultProps = {
  alertHeading: '',
  disabled: false,
  loading: false,
  errors: [],
  confirmButtonVariant: 'primary',
  confirmButtonTitle: 'Confirm',
  cancelButtonTitle: 'Cancel',
  showCancelButton: true,
  showCloseButton: true,
  showConfirmButton: true,
}

export default ConfirmModal